import { notification } from 'antd';

const openNotification = ({
    title,
    description,
    duration = 10,
    type = 'info',
    onClick = () => {},
    onClose = () => {},
    maxCount = 3,
}) => {
    notification[type]({
        message: title,
        description: description,
        duration: duration,
        onClick: () => {
            onClick();
        },
        onClose: () => {
            onClose();
        },
        maxCount: maxCount,
    });
};

export default openNotification;